import { getPDFPagesFromFile, assignIDsToPages } from 'PDFUtils';

export const setPagesFromFile = (file, actionType) => (
  async (dispatch) => {
    const pagesFromFile = await getPDFPagesFromFile(file);
    const pagesWithIDs = await assignIDsToPages(pagesFromFile);

    dispatch({
      type: actionType,
      pages: pagesWithIDs,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/PDFUtils/PDFUtilsActions.jsx